import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'
import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import * as fromGate from './gate.reducer'
import { gateActions } from './gate.actions'
import { Gate } from './gate'
import { GateService } from './gate.service'

@Injectable()
export class GateEffects extends ResourceEffects<Gate> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public gateService: GateService
  ) {
    super(fromGate.FEATURE_NAME, gateService, gateActions, actions$)
  }
}
